const SchemeTotalSideBar = ({fy_list, globalDateId, financialYearStats}) => {

    return (
        <div className="totals">
            <div
              className="bg-success-20 p-3 d-flex flex-column"
              style={{
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              <span className="text-success-100 fs-12px">
                Total Provisional Budget{" "}
                {fy_list?.map((val, ind) => {
                  return val?.id == globalDateId && val?.year;
                })}
              </span>
              <span className="text-success-100 fs-20px ">{financialYearStats?.total_provisional_budget}</span>
            </div>

            <div className="bg-white p-2 m-0">
              <h2
                className="fs-12px fw-600 m-0 p-0"
                style={{ textDecoration: "underline" }}
              >
                OPENING
              </h2>

              <div className="py-2 d-flex flex-column gap-1">
                <div className="fs-12px text-black-60">
                  Total Released FY{" "}
                  {fy_list?.map((val, ind) => {
                    return val?.id == globalDateId && val?.year;
                  })}
                </div>
                <div className="fs-14px fw-500">{financialYearStats.totalReleasedAmount}</div>
              </div>
              <div className="pb-2 d-flex flex-column gap-1">
                <div className="fs-12px text-black-60">
                  Total Previous FY Balance
                </div>
                <div className="fs-14px fw-500">{financialYearStats?.totalPrevBalance}</div>
              </div>
            </div>

            <div
              className="bg-info-20 p-3 d-flex flex-column "
              style={{
                borderTop: "1px solid #0DCAF0",
                borderBottom: "1px solid #0DCAF0",
              }}
            >
              <span className="text-black-60 fs-12px">
                Total Balance (Opening)
              </span>
              <span className="fs-20px  text-success-100 ">
                {financialYearStats.totalReleasedAmount + financialYearStats?.totalPrevBalance}
              </span>
            </div>

            <div className="bg-white p-2 m-0">
              <h2
                className="fs-12px fw-600 m-0 p-0"
                style={{ textDecoration: "underline" }}
              >
                EXPENSE
              </h2>

              <div className="py-2 d-flex flex-column gap-1">
                <div className="fs-12px text-black-60">
                  Total Under approval
                </div>
                <div className="fs-14px fw-500">{financialYearStats.totalUnderApproval}</div>
              </div>
              <div className="pb-2 d-flex flex-column gap-1">
                <div className="fs-12px text-black-60">Total Sanction</div>
                <div className="fs-14px fw-500">{financialYearStats.totalSanctionAmount}</div>
              </div>
            </div>

            <div
              className="bg-info-20 p-3 d-flex flex-column "
              style={{
                borderTop: "1px solid #0DCAF0",
                borderBottom: "1px solid #0DCAF0",
              }}
            >
              <span className="text-black-60 fs-12px">Total Expenses</span>
              <span className="fs-20px ">{financialYearStats.totalUnderApproval + financialYearStats.totalSanctionAmount}</span>
            </div>

            <div className="bg-white p-2 m-0">
              <h2
                className="fs-12px fw-600 m-0 p-0"
                style={{ textDecoration: "underline" }}
              >
                CLOSING
              </h2>

              <div className="py-2 d-flex flex-column gap-1">
                <div className="fs-12px text-black-60">
                  Total Released FY{" "} {financialYearStats.totalBalanceAmount}
                  {fy_list?.map((val, ind) => {
                    return val?.id == globalDateId && val?.year;
                  })}
                </div>
                <div className="fs-14px fw-500">{financialYearStats.totalBalanceAmount - financialYearStats.totalPrevPending}</div>
              </div>
              <div className="pb-2 d-flex flex-column gap-1">
                <div className="fs-12px text-black-60">
                  Total Previous FY Balance
                </div>
                <div className="fs-14px fw-500">{financialYearStats.totalPrevPending}</div>
              </div>
            </div>

            <div
              className="bg-success-100 p-3 d-flex flex-column "
              style={{
                borderBottomLeftRadius: "8px",
                borderBottomRightRadius: "8px",
              }}
            >
              <span className="text-white fs-12px">Total Balance (Closing)</span>
              <span className="fs-20px text-white">{financialYearStats.totalBalanceAmount}</span>
            </div>
          </div>
    )
}

export default SchemeTotalSideBar;